<script>
import { defineComponent } from "vue";
import PdfSlot from "../PdfSlot/PdfSlot.vue";
import html2pdf from 'html2pdf.js';
import PdfCartaPropostaProdutoCard from "./components/PdfCartaPropostaProdutoCard.vue";
import PdfCartaPropostaComponente from "./components/PdfCartaPropostaComponente.vue";
import PdfCartaPropostaQuantidadePreco from "./components/PdfCartaPropostaQuantidadePreco.vue";
const name = 'PdfCartaPropostaComComponentes'

export default defineComponent({
  name,

  components: { 
    PdfSlot,
    PdfCartaPropostaProdutoCard,
    PdfCartaPropostaComponente,
    PdfCartaPropostaQuantidadePreco
  }, 
  emits:['isLoading', 'pdfGenerationError'],
  props: {
    cartaPropostaId:{
      type: String,
      default: ""
    },
    nomeClientePersonalizado:{
      type: String,
      default: ""
    },
    canDownloadPdf:{
      type: Boolean,
      default: false
    },

    openPdfNewTab:{
      type: Boolean,
      default: true,
    }

   },

  mounted () { 
    //CARTA ANALITICA
    this.getPdfData().then(()=>this.canRender = true)

  },

  updated () { },

  data () {
    return {
      arrayOrcamentosInformacoes: [],
      nomeCliente:"",
      cnpjCliente:"",
      codigoCliente:"",
      nomeRepresentante:"",
      canRender: false,
      valorIpi : 0,
      valorIcms : 0,
      valorPisCofinsFormatado:"",
      formaPagamento: "",
      nomeEmpresa:"",
      codigoCartaProposta:"", 
      observacaoNegociacao:"",
      observacaoGeral:"",
     }
  },

  methods: { 
    async getPdfData(){
      this.$emit('isLoading',true)
      await this.getResumoFinalCartaProposta()
      await this.getPorcentagensImpostos()
      this.$emit('isLoading',false)
    },

    async getResumoFinalCartaProposta() {
      await this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `CartaProposta/GetResumoFinalCartaProposta/${this.cartaPropostaId}`,
      })
      .then((response) => {  
        this.nomeCliente = response.data.data.nomeCliente;
        this.cnpjCliente = response.data.data.cnpjClienteFormatado;
        this.codigoCliente = response.data.data.codigoCliente;
        this.nomeRepresentante = response.data.data.nomeRepresentante;
        this.arrayOrcamentosInformacoes =  response.data.data.orcamentosInformacoes
        this.observacaoGeral = this.arrayOrcamentosInformacoes[0].observacaoGeral
        this.observacaoNegociacao = this.arrayOrcamentosInformacoes[0].observacaoNegociacao
        this.formaPagamento = response.data.data.formaDePagamento
        this.nomeEmpresa = response.data.data.nomeEmpresa
        this.codigoCartaProposta = `#${response.data.data.codigoCarta}` 
      })
      .catch(() => {
      })      
    },

    async getPorcentagensImpostos() {
      await this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `CartaProposta/GetPorcentagensImpostos/${this.cartaPropostaId}`,
      })
      .then((response) => {
        this.valorIpi = response.data.data.porcentagemIpi
        this.valorIcms = response.data.data.porcentagemIcms
        this.valorPisCofinsFormatado = response.data.data.porcentagemPisCofinsFormatado   
        
        
      })
      .catch(() => {
      });
    },

    orcamentoComponenteArrayLinha(orcamentoComponentes){
      let arrayLinha = []
      let arrayComponentes = orcamentoComponentes
      
      
      let arrayLinhaComponente = []
      
      for (let index = 0; index < arrayComponentes.length; index++) {
        
        arrayLinhaComponente.push(arrayComponentes[index])
        
        if (index % 2 !== 0) {
          arrayLinha.push(arrayLinhaComponente)
          arrayLinhaComponente = []
        }
      }

      if (arrayLinhaComponente.length > 0) {
        arrayLinha.push(arrayLinhaComponente)
      }

      return arrayLinha
    },

    createImageHeaderFooter(imgHref) {
      const img = document.createElement("img");	
      img.src = imgHref;
      img.style.border="none"
      return img
    },

    pdfCallback(el, pdfConfigOriginal) {
      const pdfHtmlElement = el;

      const pageMarginMm = 4.5; // Margem para topo (para o cabeçalho)
      const pageWidthMm = 210; // Largura A4 em mm

      // Configuração atualizada para html2pdf com margens otimizadas
      const html2pdfConfig = {
        ...(pdfConfigOriginal || {}), // Mantém configurações originais
        
        // Configuração de quebra de página com margens explícitas
        margin: [28, 10, 15, 10], // Margens [topo, direita, inferior, esquerda] em mm - laterais reduzidas
        jsPDF: {
          unit: 'mm', // Crucial para consistência
          format: 'a4',
          orientation: 'portrait',
          ...(pdfConfigOriginal && pdfConfigOriginal.jsPDF ? pdfConfigOriginal.jsPDF : {}) // Mantém outras configs jsPDF
        },
        image: { type: 'jpeg', quality: 0.98, useCORS: true, ...(pdfConfigOriginal && pdfConfigOriginal.image) },
        html2canvas: { scale: 4, useCORS: true, ...(pdfConfigOriginal && pdfConfigOriginal.html2canvas) }
      };
      
      const headerImage = new URL("@/assets/imgs/Cabecalho_PDF_CartaProposta_PNG.png", import.meta.url);
      const headerPdf = this.createImageHeaderFooter(headerImage.href);
      
      const headerImageFirstPage = new URL("@/assets/imgs/Cabecalho_Carta_Proposta_1_PNG.png", import.meta.url);
      const headerImageFirstPagePdf = this.createImageHeaderFooter(headerImageFirstPage.href);
      
      const footerImageLastPage = new URL("@/assets/imgs/Rodape_Orcamento_inicio_PNG.png", import.meta.url);
      const footerImageLastPagePdf = this.createImageHeaderFooter(footerImageLastPage.href);
      
      const footerImage = new URL("@/assets/imgs/Rodape_CartaProposta_PNG.png", import.meta.url);
      const footerPdf = this.createImageHeaderFooter(footerImage.href);

      html2pdf().from(pdfHtmlElement).set(html2pdfConfig).toPdf().get('pdf')
      .then( (pdfInstance) => { // pdfInstance é a instância do jsPDF
        try{
          var totalPages = pdfInstance.internal.getNumberOfPages();
          
          for (let i = 1; i <= totalPages; i++) {
            pdfInstance.setPage(i);

            // Adiciona Cabeçalho
            if(i === 1){
              // Imagem ocupa largura total (pageWidthMm), X=0, Y=pageMarginMm (4.5mm do topo)
              pdfInstance.addImage(headerImageFirstPagePdf, 'Image-HTMLElement', 0, pageMarginMm, pageWidthMm, 0 );
 
              // Texto sobreposto no cabeçalho da primeira página (coordenadas absolutas da página)
              // Mantido como antes
              if(this.nomeEmpresa.includes('NORDESTE')){
                pdfInstance.setTextColor("#3f3f3f");
                pdfInstance.setFontSize(11);
                pdfInstance.setFont('Helvetica','normal');
                pdfInstance.text("Carta-Proposta",156,12);
                pdfInstance.setFont('Helvetica','bold');
                pdfInstance.text(this.codigoCartaProposta,185,12);
                pdfInstance.setLineWidth(0.5);
                pdfInstance.setDrawColor("#4f2c19");
                pdfInstance.line(180, 16, 203, 16);
                pdfInstance.setFont('Helvetica','bold');
                pdfInstance.setFontSize(11);
                pdfInstance.text(this.nomeEmpresa,127,24);
              } else {
                pdfInstance.setTextColor("#3f3f3f");
                pdfInstance.setFontSize(11);
                pdfInstance.setFont('Helvetica','normal');
                pdfInstance.text("Carta-Proposta",151,12);
                pdfInstance.setFont('Helvetica','bold');
                pdfInstance.text(this.codigoCartaProposta,179,12);
                pdfInstance.setLineWidth(0.5);
                pdfInstance.setDrawColor("#4f2c19");
                pdfInstance.line(170, 16, 197, 16);
                pdfInstance.setFont('Helvetica','bold');
                pdfInstance.setFontSize(12); 
                pdfInstance.text(this.nomeEmpresa,147,24); 
              }
            } else { // Cabeçalho para as páginas seguintes
              // Imagem ocupa largura total (pageWidthMm), X=0, Y=pageMarginMm (4.5mm do topo)
              pdfInstance.addImage(headerPdf, 'Image-HTMLElement', 0, pageMarginMm, pageWidthMm, 0);
            }

            // Adiciona Rodapé - Mantido como na última versão para avaliação posterior
            // Posições Y (272, 285) mantidas. Largura total da página (pageWidthMm), X=0.
            if (i === totalPages) { // Rodapé Última Página
              pdfInstance.addImage(footerImageLastPagePdf, 'Image-HTMLElement', 0, 272, pageWidthMm, 0 );
            } else { // Rodapé Outras Páginas
              pdfInstance.addImage(footerPdf, 'Image-HTMLElement', 0, 285, pageWidthMm, 0 );
              // Restaurando a impressão da data para páginas intermediárias
              pdfInstance.setTextColor("#FFFFFF"); // Cor Branca
              pdfInstance.setFontSize(10);
              pdfInstance.setFont('Helvetica','bold');
              pdfInstance.text(this.diaHojeFormatado,165,291); // X=170, Y ajustado para 291mm
            }
          }
        
          // Lógica para salvar ou abrir o PDF
          if(this.openPdfNewTab){
            const blobUrl = pdfInstance.output('bloburl');
            window.open(blobUrl, '_blank');
          } else {
            pdfInstance.save(`CartaProposta_${this.codigoCartaProposta}_${this.nomeCliente}.pdf`);
          }
        } catch (errorCatch) {
          console.error("Erro ao adicionar elementos manuais ao PDF:", errorCatch);
          this.$emit('pdfGenerationError', errorCatch); // Informar o componente pai sobre o erro
        }
      })
      .catch((err) => {
        console.error("Erro geral durante a geração do PDF com html2pdf:", err);
        this.$emit('pdfGenerationError', err);
      });
    },

  },

  computed: { 
    diaHojeFormatado(){
      const monthNames = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
        "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

        let today = new Date();
        return  today.getDate()+" de "+(monthNames[today.getMonth()]+" de "+ today.getFullYear());
    },
  }, 


});
</script>

<template>
    <PdfSlot v-if="canRender" :pdfCallback="pdfCallback">
      <div class="pdf-content">
       
          <div class="orcamento-item" :class="{'orcamento-divisor ':index > 0 }" v-for="orcamento,index in arrayOrcamentosInformacoes" :key="index">
            
          <div class="secao-inicial" v-if="index == 0">
            
            <div class="">
              <table>
                <tr>
                  <td><h2 style="margin-top:.8em">{{codigoCliente}}</h2></td>
                  <td>
                    <div class="titulo"> À {{ nomeCliente }}</div>
                    <div class="titulo">CNPJ. {{cnpjCliente}}</div>
                  </td>
                </tr>
              </table>
            </div>
            <p v-if="nomeClientePersonalizado"><em class="pronome-tratamento">A/Sr(a):</em> {{ ' '+nomeClientePersonalizado }} </p>
            <p> Conforme solicitado, seguem abaixo preços e condições para fornecimento, a saber </p>
          </div>
          
          <section v-if="index > 0">
            <div class="titulo-container"><h2>Orçamento: {{ orcamento.codigoOrcamento}}</h2></div>
          </section>
          
          <section>
            <div class="dados-produto-wrapper">
              <div class="dados-produto">
                <PdfCartaPropostaProdutoCard
                :nomeProduto="orcamento.nomeProduto"
                :codigoOrcamento="orcamento.codigoOrcamento"
                :opcao="orcamento.descricaoOpcao"
                :descricaoFrete="orcamento.informacaoFrete"
                />
                <div class="container-img-produto">
                  <figure v-if="orcamento.temImagem">
                    <img :src="orcamento.linkImagemProduto" class="img-sem-produto">
                  </figure>
                </div>
              </div>
            </div>
          </section>
          
          <div class="tabela-precos-wrapper">
            <div class="tabela-precos-produto">
              <PdfCartaPropostaQuantidadePreco :orcamentoDatas="orcamento.orcamentoDatas"/>
            </div>
          </div>
        
          <div class="componente-table-wrapper">
            <table class="componente-table">
              <div class="titulo-container"><h2>Composição Técnica</h2></div>
              <tr class="linha-componente" v-for="componentes,indexComp in orcamentoComponenteArrayLinha(orcamento.componentes)" :key="indexComp" >
                <PdfCartaPropostaComponente  
                v-for="componente,indexCompI in componentes"
                  :componente="componente" 
                  :index="orcamento.componentes.indexOf(componente)"
                  :key="indexCompI"
                />
            
              </tr>
            </table>
          </div>

          <section v-if="orcamento.observacaoProduto" class="">
            <div class="titulo-container"><h2 class="observacao-orcamento"> OBSERVAÇÕES DO ORÇAMENTO</h2></div>
            <p>{{ ' - Solicitação: ' + orcamento.codigoOrcamento + ' - ' + orcamento.observacaoProduto }}</p>
          </section>
        </div>

        <section class="validate-pagamento">
          <!-- <img src="@/assets/imgs/Icone_Agenda.svg" class="validade-pagamento-img"> -->
          <div class="validade-pagamento-item">
            <h3>VALIDADE DA PROPOSTA: </h3>
            <p>10 DIAS</p>
          </div>
        </section>

        <section  class="validate-pagamento">
          <!-- <img src="@/assets/imgs/Icone_Condicoes_Pagto.svg" class="validade-pagamento-img"> -->
          <div class="validade-pagamento-item">
            <h3>CONDIÇÕES DE PAGAMENTO : </h3>
            <p>{{ formaPagamento }}</p>
          </div>
        </section>
        <section class="tributacao">
          <h3>Tributações*</h3>
          <div class="icms-pis-ipi">
            <div class="tributacao-item">
              <em>ICMS</em>
              <p>{{ this.valorIcms !== 0 ? 'Incluso - '+ this.valorIcms + '%' : 'Diferido'}}</p>

            </div>
            <div class="tributacao-item">
              <em>PIS / COFINS </em>  
              <p>{{ this.valorPisCofinsFormatado  ? 'Incluso - '+ this.valorPisCofinsFormatado + '%' : 'Diferido'}}</p>
            </div>
            
            <div class="tributacao-item">
              <em>IPI</em>
              <p>{{ this.valorIpi == 0 ? 'Não Incluso - Preço acima + IPI' : 'Diferido'}}</p>
            </div>
          </div>
        </section>
        <section class="observacao-negociacao">
          <div class="titulo-container"><h2> OBSERVAÇÕES DA NEGOCIAÇÃO </h2></div>
          <p> Possível suspensão ou diferimento dependerá da apresentação da declaração expressa, nos termos da legislação vigente. </p>   
          <p>  - De acordo com Normas Gráficas (ABIGRAF) todo pedido pode ter variação na quantidade de 10% a mais ou menos.</p>
          <p>{{ this.observacaoGeral ? '- '+this.observacaoGeral : '' }}</p>
          <p>{{ this.observacaoNegociacao   ? '- '+this.observacaoNegociacao : '' }}</p>
        </section>

        <section class="finalizacao">
          <h3>Representante :<em>{{ ' '+nomeRepresentante }}</em></h3>
          
          <p><em>Sem mais para o momento,<br></em>Nos colocamos a vosso dispor</p>
        </section>      
      </div>
    </PdfSlot>
</template>


<style scoped>


.pronome-tratamento{
  font-style: normal;
  font-weight: bold;
  color: #3f3f3f;
}

h1,h2,h3,p,li,ul,ol,figure{
  margin: 0;
  padding: 0;
}

p{
  font-size: 12px;
}

h2{
  font-size: 14px;
}

h3{
  font-size: 12px;
}

h3 em {
  color: #8a8a8a;
  font-style: normal;
  font-weight: normal;
}

h2:after{
  content: "";
  display: block;
  width: 100px;
  height: 2px;
  background-color: #fcb315;
  margin-top: 8px;
  margin-bottom: 8px;
}

.orcamento-divisor {
  width: 100%;
  margin-top: 20px;
  padding: 5px;
  border-top: 1px dashed #3f3f3f87;
  
}

.finalizacao em{
  font-style: normal;
  font-weight: bold;
  color: #3f3f3f;

}

.finalizacao{
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}


.pdf-content{
  font-family: 'MontSerrat';
  width: 100%;
  padding-top: 25px;
}

.tributacao{
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #f9f9f9;
  padding: 15px;
  border-radius: 16px;
  font-size: 15px;
  position: relative;
  overflow: hidden;
  margin-bottom: 10px;
}
.tributacao-item{
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  gap: 15px;
}
.tributacao-item em{
  font-style: normal;
  font-weight: bold;
  color: #3f3f3f;
  font-size: 12px;
  
}

.icms-pis-ipi{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 15px;

}

.validate-pagamento{
  background-color: #f9f9f9;
  width: 100%;
  padding: 15px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: flex;
  gap: 15px;
  margin: 10px 0;
}

.validade-pagamento-item{
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: flex-start;
  gap: 10px;
}

.validade-pagamento-item h3 {
  padding-bottom: 0;
}

.validade-pagamento-item p {
  margin: 0;
  padding-bottom: 2px;
}

.validate-pagamento h3{
  color: #4f2c19 ;
}

.pdf-content p{
  color: #8a8a8a;
}

.pdf-content h1,.pdf-content h2,.pdf-content h3{
  color: #4f2c19;
  text-align: left;
  font-weight: 700;
  padding-bottom: 3px;
  letter-spacing: 1px;
}

.pdf-content ul{
  list-style: none;
}

.orcamento-container{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  gap:18px;
}



.dados-produto{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap:25px;

}

.container-img-produto{
  
  height: 100%;
  padding: 5px;
  width: 40%;
  /* background-color: #f9f9f9; */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  
} 
.img-sem-produto{
  width: auto;
  height: 60px;
  
}

.img-indisponivel{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 5px;
}
.secao-inicial p{
  padding: 15px 0;
}
.titulo{
  color: #4f2c19;
  text-align: left;
  font-weight: 700;
  letter-spacing: 1px;
  font-size: 14px;
  margin: 0 1em;
}
.tabela-precos-produto{
  margin: 15px 0;
}
/* Wrappers para controle de quebra de página */
.dados-produto-wrapper,
.tabela-precos-wrapper,
.componente-table-wrapper,
.tributacao-wrapper,
.titulo-container {
  width: 100%;
  margin-bottom: 10px;
  display: block;
}
.observacao-orcamento{
  margin-top: 10px;
}
.observacao-negociacao{
  margin: 10px 0;
}

</style>
